<template>
  <span>
    <form id="form" style="display:inline">
        <template>
          <input
            type="file"
            id="file"
            ref="file"
            v-on:change="handleUploadFile()"
            style="display:none"
          />
        </template>
        <v-btn
          small
          color="success"
          class="white--text font-weight-light"
          @click.stop="dialog.show = true"
        >{{buttons.bulkImport}}</v-btn>
    </form>
    <!-- Otvaranje dialoga za import -->
    <v-dialog
      v-model="dialog.show"
      persistent
      :retain-focus="false"
      :max-width="bulkProps.maxWidth"
      @keydown.esc="onCloseDialogHandler"
    >
      <v-card flat tile>
        <!-- Toolbar -->
        <v-toolbar color="primary" dark>
          <v-toolbar-title>
            <h5 class="white--text font-weight-light">
              <slot name="title">{{bulkProps.title}}</slot>
            </h5>
          </v-toolbar-title>
          <v-spacer />
          <base-icon-close @close="onCloseDialogHandler" :x_small="true"></base-icon-close>
        </v-toolbar>

        <v-card-text>
          <template v-if="dialog.component">
            <component :is="dialog.component" :href="bulkProps.href"></component>
          </template>
        </v-card-text>
        <v-col v-if="messages.length==0">
          <v-card-actions>
            <v-row no-gutters dense>
              <!-- <v-btn color="primary">Uvezi</v-btn> -->
              <v-col v-if="loading">
                <v-progress-circular :width="3" color="primary" indeterminate class="ml-8"></v-progress-circular>
              </v-col>
              <v-col v-else>
                <v-row justify="end">
                  <v-btn
                    small
                    color="success"
                    class="white--text font-weight-light mr-5"
                    @click="addFiles"
                  >{{buttons.bulkImport}}</v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-col>
        <v-col v-if="messages.length">
          <v-card-actions>
            <v-row no-gutters dense>
              <v-col v-if="loading">
                <v-progress-circular :width="3" color="primary" indeterminate class="ml-8"></v-progress-circular>
              </v-col>
              <v-row v-else>
                <v-col>
                  <v-list dense>
                    <v-list-item v-for="(error, index) in messages" :key="index">
                      <p :class="`${error.type}--text`">{{ error.message }}</p>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col>
                  <v-row justify="end">
                    <v-btn
                      small
                      color="secondary"
                      class="white--text font-weight-light mr-3"
                      @click="onCloseDialogHandler"
                    >Otkazi</v-btn>
                    <v-btn
                      small
                      color="primary"
                      class="white--text font-weight-light mr-5"
                      @click="onSubmitHandler"
                    >Pokusajte ponovo</v-btn>
                  </v-row>
                </v-col>
              </v-row>
            </v-row>
          </v-card-actions>
        </v-col>
      </v-card>
    </v-dialog>
    <!-- <v-btn
          block
          small
          color="success"
          class="white--text font-weight-light"
          @click="addFiles"
    >{{buttons.bulkImport}}</v-btn>-->
  </span>
</template>

<script>
import httpClient from '@/api/httpClient'
import translate from '@/utils/genTable/multilanguageHelper.js'

export default {
  data() {
    return {
      buttons: {
        bulkImport: translate('Import from Excel', 'buttons'),
        tryAgain: translate('Try again', 'buttons')
      },
      translatedMsg: {
        loadMsg: translate('Loading', 'notification'),
        unsuccessMsg: translate('Unsuccessfully operation', 'notification'),
        successfulyMsg: translate('Successfuly uploaded', 'notification')
      },
      dialog: {
        show: false,
        component: this.bulkProps.detailComponent
      },

      loading: false,
      notification: null,
      errors: null,
      messages: [],
      timeout: null,
      closeOnSubmit: true
    }
  },
  props: ['bulkProps'],
  components: {
    NotificationMessage: () =>
      import('@/components/notification/NotificationMessage'),
    BaseIconClose: () => import('@/components/BaseIconClose'),
    DriverDetail: () => import('@/components/bulk/DriverDetail'),
    IButtonDetail: () => import('@/components/bulk/IButtonDetail'),
    VehicleRefuelsDetail: () =>
      import('@/components/bulk/VehicleRefuelsDetail'),
    NonWorkingDaysDetails: () =>
      import('@/components/bulk/NonWorkingDaysDetails'),
    PoisDetail: () => import('@/components/bulk/PoisDetail')
  },
  methods: {
    addFiles() {
      this.$refs.file.click()
    },
    handleUploadFile() {
      /* Get the uploaded files from the input. */
      let excelFile = this.$refs.file.files
      this.makeFormDataObject(excelFile[0])
    },
    makeFormDataObject(file) {
      const formData = new FormData()
      formData.append('formFile', file)
      this.uploadFile(formData)
    },
    uploadFile(formData) {
      const endPoint = this.bulkProps.endpoint
      this.loading = true
      httpClient
        .post(endPoint, formData)
        .then(response => {
          const notification = {
            type: 'success',
            message: this.translatedMsg.successfulyMsg
          }
          this.loading = false
          this.messages.push(notification)
          this.notification = true
          this.timeout = setTimeout(() => {
            this.notification = false
          }, 3000)
          this.closeOnSubmit = true
          this.eventBus.$emit('resetTable')
          if(this.bulkProps.needToReloadPage){
            window.location.reload()
          }
        })
        .catch(error => {
          this.messages = []
          if (error.response.status == 422) {
            this.errors = error.response.data.errors
            for (const error of this.errors) {
              let notification = {
                type: 'error',
                message: error.Error
              }
              this.messages.push(notification)
            }
            this.loading = false
            this.closeOnSubmit = false
          } else {
            const notification = {
              type: 'error',
              message: this.translatedMsg.unsuccessMsg
            }
            this.loading = false
            this.messages.push(notification)
            this.closeOnSubmit = false
          }
        })
    },
    onCloseDialogHandler() {
      this.$refs.file.value = null
      this.loading = false
      this.messages = []
      this.dialog.show = false
    },
    onSubmitHandler() {
      this.$refs.file.value = null
      this.addFiles()
    }
  }
}
</script>

<style lang="scss" scoped>
.v-snack .v-snack--bottom .v-snack--has-background .v-snack--right {
  padding-top: 0px !important;
}
</style>
